module.exports = __webpack_public_path__ + "img/Logo_ZZAgentur.c3ddad1a.svg";